import React from 'react';
import { graphql, PageProps } from 'gatsby';
import Layout from '../../components/Layout';
import Seo from '../../components/SEO/seo';
import BlogHeroSection from '../../components/blog/BlogHeroSection';
import TabsSection from '../../components/blog/TabsSection';
import Posts from '../../components/blog/Posts';

const Blog = (page: PageProps) => {
  return (
    <Layout>
      <Seo page={page} title="Flow blog" />
      <main className="blog-page">
        <BlogHeroSection />
        <TabsSection activeTabIndex={1} />
        <Posts />
      </main>
    </Layout>
  );
};

export default Blog;

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
